import { clsx } from '../../../ds/clsx';
import styles from './ui.module.css';

export type DeadlineTone = 'neutral' | 'info' | 'accent' | 'warning' | 'danger' | 'success';

export interface DeadlineDotProps {
  /** Tone of the deadline as the API sends it (`deadline.tone`); an unknown value draws the neutral dot. */
  tone: string;
  /** 7 px on board cards and table rows (Backoffice 03/04), 8 px in the record's „Frist" card (05–08). */
  size?: 7 | 8 | undefined;
  className?: string | undefined;
}

const toneClass: Record<DeadlineTone, string | undefined> = {
  neutral: styles.dotNeutral,
  info: styles.dotInfo,
  accent: styles.dotAccent,
  warning: styles.dotWarning,
  danger: styles.dotDanger,
  success: styles.dotSuccess,
};

function isDeadlineTone(value: string): value is DeadlineTone {
  return value in toneClass;
}

/**
 * The traffic-light dot of a ticket deadline (Backoffice 03–08 „Fristenampel"): warning = due within 24 h,
 * success = later or solved, danger = exceeded, neutral (`--sand-400`) = paused. Decorative — the label next to it
 * carries the meaning.
 */
export function DeadlineDot({ tone, size = 7, className }: DeadlineDotProps) {
  const key: DeadlineTone = isDeadlineTone(tone) ? tone : 'neutral';
  return (
    <span
      aria-hidden="true"
      className={clsx(styles.dot, size === 8 && styles.dotLarge, toneClass[key], className)}
    />
  );
}
